import { fakePortalConfig } from "./const"

const CHECK_MOCKUP = process.env.REACT_APP_IS_MOCKUP;

// Frontend-controlled switch injected after portalConfig is fetched.
const ENABLE_LICENSE_MANAGEMENT = true;
const ENABLE_MSP_LICENSE_MANAGEMENT = true;

const withLicenseManagementConfig = (data) => ({
  ...data,
  enableLicenseManagement: ENABLE_LICENSE_MANAGEMENT,
  enableMspLicenseManagement: ENABLE_MSP_LICENSE_MANAGEMENT,
});

// API/system => /system/portalConfig
export const createSystemPortalConfigSlice = (set) => ({
  loading: false,
  portalConfig: {},
  isNavDisabled: false,
  mspLicenseAccess: { state: "inactive", entId: null },

  setIsNavDisabled: (isDisabled) => set({ isNavDisabled: isDisabled }),
  setMspLicenseAccess: (mspLicenseAccess) => set({ mspLicenseAccess }),

  fetchSystemPortalConfig: CHECK_MOCKUP === "true"
    ? () => {
      set({ portalConfig: withLicenseManagementConfig(fakePortalConfig.data) })
    } : (ws, systemPortalConfigUuid, token) => {
      const request = {
        jsonrpc: "2.0",
        id: systemPortalConfigUuid,
        method: "read",
        params: {
          resource: "/system/portalConfig",
          accessToken: token,
        },
      };
      ws.send(JSON.stringify(request));
    },

  setPortalConfigLoading: (loadingState) => set({ loading: loadingState }),
  setPortalConfig: (data) => set({ portalConfig: withLicenseManagementConfig(data) }),
});
